module.exports = __webpack_public_path__ + "img/wheel.58536e63.png";